import { $getSelection, $isRangeSelection, FORMAT_TEXT_COMMAND } from "lexical";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Bold } from "lucide-react";

import { useButtonState } from "../useButtonState";

export function BoldButton() {
    const [editor] = useLexicalComposerContext();
    const isActive = useButtonState(() => {
        const selection = $getSelection();
        return $isRangeSelection(selection) && selection.hasFormat("bold");
    });

    return (
        <button
            type="button"
            className="rte-toolbar-button"
            data-active={isActive}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "bold")}
            title="Bold"
            aria-label="Bold"
        >
            <Bold size={16} />
        </button>
    );
}
